import { render, staticRenderFns } from "./layout-footer.vue?vue&type=template&id=b8d2f752"
import script from "./layout-footer.vue?vue&type=script&lang=js"
export * from "./layout-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports